import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from '../ui/Button';

/**
 * Saisie minimaliste des clés Stancer (publique + privée).
 */
export default function StancerKeysForm({
  publicKey,
  privateKey,
  onPublicKeyChange,
  onPrivateKeyChange,
  publicConfigured = false,
  privateConfigured = false,
  keysConfigured = false,
  saving = false,
  onSubmit,
  submitLabel = 'Enregistrer',
  className = '',
}) {
  const [showPrivate, setShowPrivate] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.();
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-4 ${className}`}>
      <div
        className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm ${
          keysConfigured
            ? 'bg-emerald-500/10 text-emerald-800 dark:text-emerald-300'
            : 'bg-muted/50 text-muted-foreground'
        }`}
      >
        <Icon
          name={keysConfigured ? 'CheckCircle' : 'CreditCard'}
          size={18}
          className={keysConfigured ? 'text-emerald-600' : 'text-muted-foreground'}
        />
        <span>{keysConfigured ? 'Paiement en ligne activé' : 'Clés non renseignées'}</span>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1 block">Clé publique</label>
        <input
          type="text"
          value={publicKey}
          onChange={(e) => onPublicKeyChange(e.target.value)}
          placeholder={publicConfigured ? 'Déjà enregistrée — saisir pour remplacer' : 'pk_live_…'}
          autoComplete="off"
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        />
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1 block">Clé secrète</label>
        <div className="relative">
          <input
            type={showPrivate ? 'text' : 'password'}
            value={privateKey}
            onChange={(e) => onPrivateKeyChange(e.target.value)}
            placeholder={privateConfigured ? 'Déjà enregistrée — saisir pour remplacer' : 'sk_live_…'}
            autoComplete="new-password"
            className="w-full rounded-md border border-input bg-background px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
          <button
            type="button"
            className="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 rounded text-muted-foreground hover:bg-muted"
            onClick={() => setShowPrivate((v) => !v)}
            aria-label={showPrivate ? 'Masquer' : 'Afficher'}
          >
            <Icon name={showPrivate ? 'EyeOff' : 'Eye'} size={16} />
          </button>
        </div>
      </div>

      {onSubmit ? (
        <Button type="submit" disabled={saving} className="w-full sm:w-auto">
          {saving ? 'Enregistrement…' : submitLabel}
        </Button>
      ) : null}
    </form>
  );
}
